module.exports = __webpack_public_path__ + "static/media/afex.41c1b379.png";